<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2A7IXr/tc-custom/9781910859452.jpg?1726871176449" alt="This image is the cover for the book Jello Salad"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jello Salad
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A mob wife opens a London restaurant, serving a full banquet of mayhem and violence in this “riotously good read” by the author of <i>Acid Casuals</i> (<i>Observer</i>).</b></p><p> They’re opening a new restaurant in London’s posh SoHo district. Susan Ball, a mob wife turned restaurateur, is funding the joint with money she stole from her notorious husband, Frank ‘Ballistic’ Ball. The cook is a former celebrity chef whose insatiable perversions were too hot for TV. And as for the Maitre D, his drug-fueled spiritual journey in Goa has certainly made him more unique, but it hasn’t made him any more trustworthy. This might sound like a recipe for disaster—but that’s just the first course. </p><p><b>‘This black comedy of modern bad manners aims at outrage and hits the bull’s eye every time . . . A must-read” —Val McDermid</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicholas Blincoe
      </h2>
      
      <p class="authorDescription body article"><P>Nicholas Blincoe is an author, critic and screenwriter. His many novels include the highly-acclaimed Manchester Slingback, which won the CWA Silver Dagger award in 1998. Born in Rochdale, he attended the University of Warwick, where he completed a PhD in contemporary European philosophy.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44769d21